<template>
   <div>
      <div class="row mt-3 mb-2">
         <div class="col-12">
            <h6>Total de piezas requeridas: {{totalRequired}}</h6>
            <h6>Total de piezas agregadas: {{totalAdded}}</h6>
            <h6>Total de piezas faltantes: {{totalMissing}}</h6>
         </div>
      </div>
      <div class="row mb-3" v-if="!completed">
         <div class="col-12">
            <button type="button" class="btn btn-primary-rgba my-1" @click.stop="onAddProdRequest" ><i class="feather icon-shopping-bag mr-2"></i>Agregar {{singularName}}</button>
         </div>
      </div>
      <div class="row" v-if="hasItems">
         <div class="col-lg-8">
            <div class="">
               <div class="cart-head">
                  <h6>Lista de {{pluralName}} seleccionados</h6>
                  <div class="table-responsive">
                     <table class="table">
                        <thead>
                           <tr>
                              <th scope="col">Producto</th>
                              <th scope="col">Piezas</th>
                              <th scope="col" v-if="!forGifts">Total</th>
                              <th scope="col">Acciones</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="(p, idx) in productsAdded" :key="idx">
                              <td>{{p.name}}</td>
                              <td>{{p.pieces}}</td>
                              <td v-if="!forGifts">{{explicitMoneyFormat(p.total)}}</td>
                              <td>
                                 <a class="text-info cursor-pointer mr-4 font-20" @click.stop="editProductRequest(p.id)"><i class="feather icon-edit"></i></a>
                                 <a class="text-danger cursor-pointer font-20" @click.stop="deleteProductRequest(p.id)"><i class="feather icon-trash"></i></a>
                              </td>
                           </tr>
                           <tr v-if="!forGifts">
                              <td></td>
                              <td><span class="high-row-font">TOTAL</span></td>
                              <td><span class="high-row-font">{{formattedTotalAmount}}</span></td>                              
                              <td></td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <vs-popup :active.sync="promptActive" :title="promptTitle">
         <div class="card">
            <div class="card-body py-0">
               <div class="row">
                  <div class="col-12">
                     <h6 v-if="onEdit">Modifique la cantidad para el {{singularName}}:</h6>
                     <h6 v-else>Seleccione un {{singularName}} de la lista:</h6>
                  </div>
                  <div class="col-12" v-if="onEdit"><p class="font-16 bold my-1">{{editProdName}}</p></div>
                  <div class="col-12 brime-select" v-if="!onEdit">
                     <select2
                        v-model="currentProdId"
                        :options="productsCollection"
                        :settings="{minimumResultsForSearch: 20}" />
                  </div>
               </div>
               <hr class="my-3">
               <div class="row align-items-center mt-2">
                  <div class="col-lg-7 col-6 text-right">
                     <span class="font-15" v-if="!prodSelected">Cantidad:</span>
                     <span class="font-15" v-else>Cantidad ( máximo {{maxSelect}} ): </span>
                  </div>
                  <div class="col-lg-5 col-6 text-right">
                     <input type="number" :disabled="!prodSelected" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputPieces" id="inputPieces" min="1" v-model="currentPieces">
                  </div>
                  <div class="col-12 text-right mt-1" v-if="errorMssg">
                     <div class="text-error">{{errorMssg}}</div>
                  </div>
               </div>
               <div class="row align-items-center mt-2" v-if="!forGifts">
                  <div class="col-lg-5 offset-lg-7 col-10 offset-2 text-right mb-2">
                     <div class="input-group mt-1">
                        <div class="input-group-prepend">
                           <span class="input-group-text">$</span>
                        </div>
                        <input type="text" class="form-control-plaintext pl-3 form-control-mid" name="inputStaticValue" id="inputStaticValue" readonly v-model="formattedAmount" >
                     </div>
                  </div>
               </div>
               <hr class="mt-3 mb-2">
               <div class="row">
                  <div class="col-12">
                     <button type="button" class="btn btn-info float-right mt-2 mb-1 ml-auto" @click.stop="onAddProduct" >
                        {{onEdit ? "Actualizar" : "Agregar" }}
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </vs-popup>
   </div>
   
</template>

<script>
import {Promotion} from "@classes/promotion"
import Select2 from 'v-select2-component';
import formatHelper from "@mixins/formatHelper"
export default {
   name: "PromoProductsSelect",
   mixins: [formatHelper],
   props: {
      promotion: { type: [Promotion, Object] },
      promoQuantity: { type: [String, Number], default: 1 },
      totalRequired: { type: Number, required: true },
      selectionableProducts: { type: Array},
      singularName: {type: String, default: "producto"},
      pluralName: {type: String, default: "productos"},
      prechargedProducts: {type: Array, default: []},
      forGifts: {type: Boolean, default: false}
   },
   components: {
      Select2
   },
   mounted(){
      this.setDefaults()
      // llamada inicial para resetear variables
      this.selectionChanged()
   },
   data() {
      return {
         addTitle:`Agregar ${this.singularName}`,
         updateTitle:`Actualizar ${this.singularName}`,
         currentProdId: null,
         currentPieces: 1,
         initEditPieces: 0,
         productsAdded: [],
         promptActive: false,
         hasError: false,
         errorMssg: null,
         onEdit: false,
         editProdName: null,
      }
   },
   computed: {
      formattedAmount(){
         if(this.prodSelected){
            return this.fixedFormat(this.calculateTotalForProd(this.currentProduct, this.currentPieces), 2)
         }
         return null
      },
      formattedTotalAmount() {
        let t = 0;
        this.productsAdded.forEach(f => {t += f.total })
        return this.explicitMoneyFormat(t)
      },
      promptTitle(){
         return this.onEdit ? this.updateTitle : this.addTitle
      },
      productsCollection(){
         if(this.selectionableProducts && this.selectionableProducts.length){
            let prods = []
            this.selectionableProducts.forEach(f => {
               if(!this.productsAdded.some(p => p.id === f.id)){
                  prods.push({id: f.id, text: `${f.name}, (${f.stock} disponibles)`})
               }
            })
            return prods
         }
         return []
      },
      hasItems() {
         return (this.productsAdded && this.productsAdded.length > 0)
      },
      prodSelected(){
         return (this.currentProdId !== null)
      },
      idProdSelected(){
         if (this.currentProdId !== null){
            return parseInt(this.currentProdId)
         }
         return null
      },
      currentProduct(){
         return this.selectionableProducts.find(f => f.id === this.idProdSelected)
      },
      maxSelect(){
         if(this.prodSelected){
            if(this.onEdit){
               return Math.min(this.currentProduct.stock, (this.totalMissing + this.initEditPieces))
            }
            else {
               return Math.min(this.currentProduct.stock, this.totalMissing)
            }
         }
         else {
            return 1
         }
      },
      totalAdded(){
         let c = 0
         this.productsAdded.forEach(f => {c += f.pieces})
         return c
      },
      totalMissing(){
         return this.totalRequired - this.totalAdded
      },
      completed(){
         return this.totalAdded === this.totalRequired
      }
   },
   methods: {
      setDefaults(){
         this.productsAdded = this.prechargedProducts
      },
      async onAddProdRequest(){
         this.resetError()
         this.currentProdId = null
         this.currentPieces = 1
         this.onEdit = false
         this.promptActive = true
      },
      async onAddProduct(){
         if(!this.currentProdId){
            this.errorMssg = "Por favor seleccione un producto de la lista"
            return
         }

         const rpieces = parseInt(this.currentPieces)
         if(Number.isNaN(rpieces) || rpieces < 1 || rpieces > this.maxSelect){
            this.errorMssg = "Por favor seleccione una cantidad válida"
            return
         }
         const total = this.calculateTotalForProd(this.currentProduct, rpieces)
         this.resetError()
         const prev = this.productsAdded.find(f => f.id === this.idProdSelected)
         if(prev){
            prev.pieces = rpieces
            prev.total = total
         }
         else {
            this.productsAdded.push({id: this.idProdSelected, name: this.currentProduct.name, pieces: rpieces, total: total})
         }
         this.promptActive = false
         this.selectionChanged()
      },
      resetError(){
         this.errorMssg = null
      },
      calculateTotalForProd(prod, pieces){
         if(this.forGifts){
            return 0
         }
         return Math.max(prod.cost * pieces, 0)
      },
      deleteProductRequest(id){
         this.productsAdded = this.productsAdded.filter(f => f.id !== id)
         this.selectionChanged()
      },
      async editProductRequest(id){
         this.resetError()
         this.currentProdId = id
         this.currentPieces = this.productsAdded.find(f => f.id === id).pieces
         this.initEditPieces = this.currentPieces
         const prod = this.selectionableProducts.find(f => f.id === id)
         this.editProdName = `${prod.name}, (${prod.stock} disponibles)`
         this.onEdit = true
         this.promptActive = true
      },
      selectionChanged(){
         this.$emit("on-selection-changed", this.completed)
      },
      // to be called by a parent component
      getSelectedProducts(){
         return this.productsAdded
      },
   }
}
</script>